import { Position } from 'react-virtualized'
import {
  ADD_CLIENT,
  DEACTIVATE_CLIENT,
  GET_CLIENT,
  GET_CLIENT_ACCOUNT_TOTAL,
  GET_CLIENT_ROLES,
  GET_CLIENTS,
  UPDATE_CLIENT,
  GET_CLIENTS_BEFORE,
  GET_CLIENTS_AFTER,
  GET_CLIENT_DEALS,
  GET_CLIENT_CASHFLOWS,
  GET_CLIENT_DEALS_ERROR,
  GET_CLIENT_CASHFLOWS_ERROR,
  GET_CLIENT_TAX_POSITION,
  GET_CLIENT_TAX_POSITION_ERROR,
  GET_CLIENT_TAX_SUMMARY,
  GET_CLIENT_TAX_SUMMARY_ERROR,
  GET_CLIENT_PERSON,
  GET_POSITION_BUYS,
  VALID_CLIENT,
  GET_CLIENT_ACCOUNTS
} from '../actionTypes'
import { Client, ClientCashflow, ClientDeal, ClientName, ClientPerson, ClientRole, ClientTaxPosition, ClientTaxSummary } from '../reducers/clients'
import { Account } from '../reducers/portfolio'

export const getClientsAction = (clients: Client[]) => ({ type: GET_CLIENTS, payload: clients })
export const getClientsActionBefore = () => ({ type: GET_CLIENTS_BEFORE })
export const getClientsActionAfter = () => ({ type: GET_CLIENTS_AFTER })

export const getClientAction = (client: Client) => ({ type: GET_CLIENT, payload: client })
export const addClientAction = (client: Client) => ({ type: ADD_CLIENT, payload: client })
export const updateClientAction = (client: Client) => ({ type: UPDATE_CLIENT, payload: client })
export const validClientAction = (clientName: ClientName) => ({ type: VALID_CLIENT, payload: clientName })
export const deactivateClientAction = (client: Client) => ({ type: DEACTIVATE_CLIENT, payload: client })
export const getClientRolesAction = (clientRoles: ClientRole[]) => ({ type: GET_CLIENT_ROLES, payload: clientRoles })
export const getClientPersonsAction = (clientPersons: ClientPerson[]) => ({ type: GET_CLIENT_PERSON, payload: clientPersons })
export const getClientAccountTotalAction = (clientAccountTotal: Number) => ({
  type: GET_CLIENT_ACCOUNT_TOTAL,
  payload: clientAccountTotal,
})

export const getClientDealsAction = (clientDeals: ClientDeal[]) => ({type: GET_CLIENT_DEALS, payload: clientDeals})
export const getClientDealsActionError = () => ({type: GET_CLIENT_DEALS_ERROR, payload: []})
export const getClientCashflowsAction = (clientCashflows: ClientCashflow[]) => ({type: GET_CLIENT_CASHFLOWS, payload: clientCashflows})
export const getClientCashflowsActionError = () => ({type: GET_CLIENT_CASHFLOWS_ERROR, payload: []})

export const getClientTaxPostitionAction = (clientTaxPostions: ClientTaxPosition[]) => ({type: GET_CLIENT_TAX_POSITION, payload: clientTaxPostions})
export const getClientTaxPostitionActionError = () => ({type: GET_CLIENT_TAX_POSITION_ERROR, payload: []})

export const getClientTaxSummaryAction = (clientTaxSummary: ClientTaxSummary[]) => ({type: GET_CLIENT_TAX_SUMMARY, payload: clientTaxSummary})
export const getClientTaxSummaryActionError = () => ({type: GET_CLIENT_TAX_SUMMARY_ERROR, payload: []})
export const getPositionBuysAction = (id: Number, buys: Position[]) => ({ type: GET_POSITION_BUYS, payload: {id: id, buys: buys}})
export const getClientAccountsAction = (accounts: Account[]) => ({type: GET_CLIENT_ACCOUNTS, payload: {accounts: accounts}})